import React from 'react';
import ReactDOM from 'react-dom/client';
import APIHubPortal from './APIHubPortal';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <APIHubPortal />
  </React.StrictMode>
);
